import React from 'react';
import { ListIcon, Layers, Activity, Sun, Moon, LogOut } from 'lucide-react';

const MenuView = ({ activeTab, setActiveTab, darkMode, setDarkMode, handleLogout, styles }) => {
    return (
        <div style={{padding: '0 0 80px 0', color: darkMode ? '#fff' : '#000'}}>
            <h2 style={{fontSize: '20px', marginBottom: '20px', color: darkMode ? '#fff' : '#333'}}>메뉴</h2>
            
            <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                <button 
                    onClick={() => setActiveTab('locations')}
                    style={{padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '15px', color: 'inherit', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}
                >
                    <ListIcon size={24} color="#0088FE" />
                    <div>
                        <div style={{fontWeight: 'bold'}}>위치 관리</div>
                        <div style={{fontSize: '12px', opacity: 0.7}}>공간 구조 및 위치별 물품 확인</div>
                    </div>
                </button>

                <button 
                    onClick={() => setActiveTab('categories')}
                    style={{padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '15px', color: 'inherit', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}
                >
                    <Layers size={24} color="#00C49F" />
                    <div>
                        <div style={{fontWeight: 'bold'}}>카테고리/태그 관리</div>
                        <div style={{fontSize: '12px', opacity: 0.7}}>물품 분류 및 태그 편집</div>
                    </div>
                </button>

                <button 
                    onClick={() => setActiveTab('health')}
                    style={{padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '15px', color: 'inherit', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}
                >
                    <Activity size={24} color="#FFBB28" />
                    <div>
                        <div style={{fontWeight: 'bold'}}>시스템 상태</div>
                        <div style={{fontSize: '12px', opacity: 0.7}}>DB 연결, 디스크 용량 확인</div>
                    </div>
                </button>

                 <button 
                    onClick={() => setDarkMode(!darkMode)}
                    style={{padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '15px', color: 'inherit', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}
                >
                    {darkMode ? <Sun size={24} color="#FF8042" /> : <Moon size={24} color="#8884d8" />}
                    <div>
                        <div style={{fontWeight: 'bold'}}>{darkMode ? '라이트 모드' : '다크 모드'}</div>
                        <div style={{fontSize: '12px', opacity: 0.7}}>화면 테마 변경</div>
                    </div>
                </button>

                 <button 
                    onClick={handleLogout}
                    style={{padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '15px', color: 'inherit', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}
                >
                    <LogOut size={24} color="#ff4d4d" />
                    <div>
                        <div style={{fontWeight: 'bold'}}>로그아웃</div>
                        <div style={{fontSize: '12px', opacity: 0.7}}>계정 로그아웃</div>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default MenuView;
